import API from '@/views/Fdc/Apis'
import _ from 'lodash'
import EqpCopyModal from '@/views/Fdc/EqpInfo/Components/EqpCopyModal'

/**
 * Detection > Detection Model Grid component
 */
export default {
  name: 'ModelGrid',
  components: {
    'eqp-copy-modal': EqpCopyModal // 기준정보 Copy Modal component
  },
  watch: {
    /**
     * rowData 변화 감지
     * @param {*} e row data
     */
    rowData: function (rows) {
      // this._updateComboBoxInGrid(e)
      this.updateFilterComboBox(rows)
    }
  },
  beforeMount () {
    this.initColumns()
  },
  props: {
    modelType: {
      type: String,
      default: ''
    },
    uvaType: {
      type: String,
      default: ''
    },
    selectedTreeNode: {
      type: [Array, Object],
      default: () => []
    }
  },
  methods: {
    // BRIQUE GRID에 필요한 method - start
    /**
     * Detection Type별 grid column 설정
     */
    initColumns () {
      // BRIQUE grid version
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', hide: true }
      ]

      if (this.modelType === 'UVA') {
        // this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', width: 180, checkboxSelection: true, headerCheckboxSelection: true, editable: function (params) { return params.node.data.briqueGridCud === 'C' }, headerClass: 'header-required' })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', width: 180, checkboxSelection: true, headerCheckboxSelection: true, modifiable: false, required: true }) // , filterFramework: 'briqueGridCustomFilter'
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80, modifiable: false, required: true })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 65, modifiable: false, required: true }) // , filterFramework: 'briqueGridCustomFilter'
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'uvaType', width: 100, required: true, editable: false })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.ACTIVE'), field: 'active', width: 65, type: 'checkboxColumn', dataMapping: { key: 'activeYn', true: 'Y', false: 'N' } })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.ACTIVE'), field: 'activeYn', width: 65, hide: true })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.SETTLING_TIME'), field: 'settlingTime', width: 65, type: 'numericColumn' })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), field: 'activationTime', width: 65, type: 'numericColumn' })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'uslVal', width: 60, type: 'numericColumn', editable: true })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'uclVal', width: 60, type: 'numericColumn' })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lclVal', width: 60, type: 'numericColumn' })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lslVal', width: 60, type: 'numericColumn' })
        this.columns.push({ headerName: this.$t('fdc.FAULT_DETECTION.COLUMN.STEP_LIST'), field: 'stepList', hide: true })
      } else {
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODEL_NAME'), field: 'modelName', width: 180, checkboxSelection: true, headerCheckboxSelection: true, modifiable: false, required: true })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODEL_ALIAS'), field: 'modelAlias', editable: true })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'mvaType', width: 100, editable: false })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.ACTIVE'), field: 'active', width: 65, type: 'checkboxColumn', dataMapping: { key: 'activeYn', true: 'Y', false: 'N' } })
        this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.ACTIVE'), field: 'activeYn', width: 65, hide: true })
      }
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false })
    },
    /**
     * BRIQUE Grid cell editing start method
     * @param {*} params 현재 row 연관 data
     */
    async onCellEditingStarted (params) {
      this.getStepListData(params.data)
      params.data.stepList = this.stepDataMap
      let stepList = []
      this.stepDataMap.forEach(item => {
        if (!stepList.includes(item.stepId)) {
          stepList.push(item.stepId)
        }
      })
      this.columns.map(c => {
        if (c.field === 'stepId') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: stepList
          }
        }
        return c
      })
      this.$refs.modelGrd.gridApi.setColumnDefs(this.columns)
    },

    /**
     * Step data 조회
     * @param {*} data 현재 row의 data (입력한 Recipe ID 포함)
     */
    async getStepListData (data) {
      let payload = {
        fab: data.fab,
        eqpId: data.eqpId,
        moduleId: data.moduleId,
        recipeId: data.recipeId
      }
      this.stepDataMap = await API.BaseInfo.getEqpRecipeSteps(payload)
      this.stepDataMap = [{ stepId: 'ALL' }].concat(this.stepDataMap)
    },
    /**
     * Detection Model grid dataMap 설정
     * @param {*} selectEqpVo EQP Tree node detail Object
     */
    setDataMap (selectEqpVo) {
      if (this.modelType === 'MVA') return
      this.getUvaTypeDataMap(selectEqpVo)
      this.getParamDataMap(selectEqpVo)
      this.getRecipeDataMap(selectEqpVo)
    },
    /**
     * Model UVA Type dataMap 설정
     */
    async getUvaTypeDataMap () {
      let payload = { codeType: 'MODEL_UVA_TYPE' }
      await API.Common.getCodes(payload, this.getUvaTypeDataMapCallback)
    },
    getUvaTypeDataMapCallback (response) {
      if (response.status === 200 && response.data) {
        this.codeDataMap = response.data
        // MODEL_UVA_TYPE
        this.columns.map(c => {
          if (c.field === 'uvaType') {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: this.codeDataMap
            }
          }
          return c
        })
        this.$refs.modelGrd.gridApi.setColumnDefs(this.columns)
        // const col = this.modelGrd.getColumn('uvaType')
        // col.dataMap = this.codeDataMap
      }
    },
    /**
     * Parameter Name dataMap 설정
     * @param {*} selectEqpVo EQP Tree node detail Object
     */
    async getParamDataMap (selectEqpVo) {
      // selectEqpVo.numberYn = 'Y' // NOTE: eqpTree selected 되지 않는 버그 유발하여 주석처리함
      const _selectEqpVo = { ...selectEqpVo, numberYn: 'Y' }
      this.paramNameDataMap = await API.BaseInfo.getEqpParams(_selectEqpVo)

      this.columns.map(c => {
        if (c.field === 'paramName') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: this.paramNameDataMap.map(data => data.paramName)
          }
        }
        return c
      })
      this.$refs.modelGrd.gridApi.setColumnDefs(this.columns)

      // this.dataMapSetting(this.paramNameDataMap, 'paramName')
    },
    /**
     * Recipe dataMap 설정
     * @param {*} selectEqpVo EQP Tree node detail Object
     */
    async getRecipeDataMap (selectEqpVo) {
      this.recipeDataMap = await API.BaseInfo.getEqpRecipes(selectEqpVo)

      this.columns.map(c => {
        if (c.field === 'recipeId') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: ['ALL'].concat(this.recipeDataMap.map(data => data.recipeId))
          }
        }
        return c
      })
      this.$refs.modelGrd.gridApi.setColumnDefs(this.columns)

      // this.dataMapSetting([{ recipeId: 'ALL' }].concat(this.recipeDataMap), 'recipeId')
    },
    /**
     * 선택된 EQP Tree node로 Detection Model 조회
     */
    searchModel () {
      let node = this.selectedTreeNode
      if (node.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      if (node.detail.eqpModel === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP Model']))
        return
      }
      if (node.detail.eqpId === '' || node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module']))
        return
      }
      this.searchTreeNode = node
      this.searchModelList(node.detail)
    },
    /**
     * Detection Model 재조회
     */
    refreshModel () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.searchModelList(selectEqpVo)
      }
      this.filterParam = null
      this.filterRecipe = null
      this.filterStep = null
    },
    /**
     * check된 row가 있는지 여부 체크
     * @returns {*} check된 row가 있는지 여부
     * Save, Delete Button 활성화를 제어합니다.
     */
    hasCheckedRows () {
      if (!this.$refs.modelGrd) {
        return 0
      }
      return this.$refs.modelGrd.checkedRowCount > 0
    },
    /**
     * Detection Model 조회
     * @param {Object} nodeDetail EQP Tree node detail Object
     */
    async searchModelList (nodeDetail) {
      let payload = {
        fab: nodeDetail.fab,
        eqpId: nodeDetail.eqpId,
        moduleId: nodeDetail.moduleId,
        modelType: this.modelType,
        uvaType: this.uvaType
      }

      let data = null
      const biz = payload.modelType.toLowerCase()
      if (biz === 'uva') {
        data = await API.Model.getUvaModels(payload)
      } else {
        data = await API.Model.getMvaModels(payload)
      }

      data.forEach(d => {
        if (d.activeYn === 'Y') {
          d.active = true
        } else {
          d.active = false
        }
      })
      this.rowData = data

      this.setDataMap(nodeDetail)
      // setTimeout(() => {
      //   this._updateFilterComboBox()
      // }, 20)
    },
    onRowDataChanged () {
      this.$emit('select-prev-node')
    },
    /**
     * 검색 여부 체크
     * @returns {Boolean} 검색 여부
     * Add Button 활성화를 제어합니다.
     */
    isSearchNode () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (!this.isEmpty(selectEqpVo.fab) &&
          !this.isEmpty(selectEqpVo.eqpId) &&
          !this.isEmpty(selectEqpVo.moduleId)) {
          return true
        }
        return false
      }
    },
    /**
     * Detection Model 행 추가
     */
    newRowAdd () {
      const selectEqpVo = this.searchTreeNode.detail
      const modelUVA = {
        fab: selectEqpVo.fab,
        eqpId: selectEqpVo.eqpId,
        moduleId: selectEqpVo.moduleId,
        paramName: '',
        recipeId: 'ALL',
        stepId: 'ALL',
        stepList: 'ALL,',
        uvaType: this.uvaType,
        activeYn: 'N',
        settlingTime: 3,
        activationTime: -1
      }
      const modelMVA = {
        fab: selectEqpVo.fab,
        eqpId: selectEqpVo.eqpId,
        moduleId: selectEqpVo.moduleId,
        modelName: '',
        modelAlias: '',
        mvaType: 'T2',
        activeYn: 'N'
      }

      let arr = this.modelType === 'UVA' ? modelUVA : modelMVA

      // this.$refs.modelGrd.paramName.readOnly = false
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.modelGrd.addRows(arr, status)

      this.$refs.modelGrd.addRowOne(arr)
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        var currentRow = rows[0]
        this.$emit('model-row-selected', currentRow)
      } else {
        // reset data
        this.$emit('model-row-selected', null)
      }
    },
    /**
     * Detection Model 저장
     */
    async saveData () {
      const that = this
      // const allRows = this.$refs.modelGrd.rows

      let saveRows = []
      const checkedRows = this.$refs.modelGrd.getCheckedRows()
      const addedRows = this.$refs.modelGrd.getAddedRows()
      const updatedRows = this.$refs.modelGrd.getUpdatedRows()
      // 선택된 데이터가 없습니다.
      if (checkedRows.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없습니다.
      if (saveRows.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      if (!_.isEqual(saveRows.length, (addedRows.length + updatedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      // if (this.saveDataValidCheck()) {
      //   return
      // }

      let payload = {
        modelType: this.modelType,
        dataList: saveRows
      }

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          // const responseData = await API.FdcDetection.saveModelList(payload)
          let responseData = null
          const biz = payload.modelType.toLowerCase()
          if (biz === 'mva') {
            responseData = await API.Model.addMvaModel(payload)
          } else if (biz === 'uva') {
            responseData = await API.Model.addUvaModel(payload)
          }

          if (responseData != null && responseData.status === 200) {
            that.$dialog.alert(successMessage)
            that.refreshModel()
          } else {
            that.$dialog.alert(failMessage)
          }
        }
      })
    },

    /**
     * Detection Model 삭제
     */
    async deleteData () {
      const that = this
      const checkedRows = this.$refs.modelGrd.getCheckedRows()
      let addedRow = []
      let deleteRow = []

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus !== 'C') {
          // 데이터 삭제 할 로우
          deleteRow.push(row)
        } else {
          // grid에서 그냥 삭제할 로우
          // FIXME: 필요 여부 판단
          addedRow.push(row)
        }
      })

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')
      const complateMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

      let payload = {
        modelType: this.modelType,
        dataList: deleteRow
      }

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          if (deleteRow.length > 0) {
            // await API.FdcDetection.deleteModelList(payload)
            const biz = payload.modelType.toLowerCase()
            if (biz === 'mva') {
              await API.Model.deleteMvaModel(payload) // mva
            } else if (biz === 'uva') {
              await API.Model.deleteUvaModel(payload) // uva
            }
          }
          that.$dialog.alert(complateMessage)
          that.refreshModel()
        }
        // onCancel: function () {}
      })
    },

    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * Grid filter change event
     * Parameter, Recipe, Step filter change event를 설정합니다.
     */
    changeFilter () {
      // ag-grid version
      this.$refs.modelGrd.gridApi.onFilterChanged()
    },
    /**
     * BRIQUE Grid External Filter 적용 여부 check
     * @returns {Boolean} check result
     */
    isExternalFilterPresent () {
      return !this.isEmpty(this.filterParam) || !this.isEmpty(this.filterRecipe) || !this.isEmpty(this.filterStep)
    },
    /**
     * BRIQUE Grid filter function
     * @param {*} node row data
     * @returns {Boolean} filter result
     */
    doesExternalFilterPass (node) {
      if ((this.filterParam === null || this.filterParam === '' || node.data.paramName.indexOf(this.filterParam) > -1) &&
        (this.filterRecipe === null || this.filterRecipe === '' || node.data.recipeId.indexOf(this.filterRecipe) > -1) &&
        (this.filterStep === null || this.filterStep === '' || node.data.stepId.indexOf(this.filterStep) > -1)) {
        return true
      } else {
        return false
      }
    },
    /**
     * Grid filter combobox data 설정
     * Parameter, Recipe, Step filter의 data를 설정합니다.
     */
    updateFilterComboBox (rows) {
      if (this.modelType !== 'MVA') {
        // let rows = this.$refs.modelGrd.oriData
        // console.log(this.$refs.modelGrd.oriData)
        let paramFilterArray = []
        let recipeFilterArray = []
        let stepFilterArray = []
        for (let i = 0; i < rows.length; i++) {
          if (!paramFilterArray.includes(rows[i].paramName)) {
            paramFilterArray.push(rows[i].paramName)
          }
          if (!recipeFilterArray.includes(rows[i].recipeId)) {
            recipeFilterArray.push(rows[i].recipeId)
          }
          if (!stepFilterArray.includes(rows[i].stepId)) {
            stepFilterArray.push(rows[i].stepId)
          }
        }
        this.filterParamArray = paramFilterArray.sort()
        this.filterRecipeArray = recipeFilterArray.sort()
        this.filterStepArray = stepFilterArray.sort()
      }
      // if (this.modelType !== 'MVA') {
      //   let rows = this.modelGrd.rows
      //   let paramFilterArray = []
      //   let recipeFilterArray = []
      //   let stepFilterArray = []
      //   for (let i = 0; i < rows.length; i++) {
      //     if (!paramFilterArray.includes(rows[i].dataItem.paramName)) {
      //       paramFilterArray.push(rows[i].dataItem.paramName)
      //     }
      //     if (!recipeFilterArray.includes(rows[i].dataItem.recipeId)) {
      //       recipeFilterArray.push(rows[i].dataItem.recipeId)
      //     }
      //     if (!stepFilterArray.includes(rows[i].dataItem.stepId)) {
      //       stepFilterArray.push(rows[i].dataItem.stepId)
      //     }
      //   }
      //   this.filterParamArray = paramFilterArray.sort()
      //   this.filterRecipeArray = recipeFilterArray.sort()
      //   this.filterStepArray = stepFilterArray.sort()
      // }
    },
    /**
     * 기준정보 Copy Modal 열기
     */
    openCopyModal () {
      this.eqpCopyModal.visible = true
    },
    /**
     * 기준정보 Copy Modal 닫기
     */
    resetCopyModalData (value) {
      this.eqpCopyModal.visible = value
    },
    // BRIQUE GRID에 필요한 method - end
    /**
     * Save Validation
     * @returns {Boolean} validation 성공 여부
     */
    saveDataValidCheck () {
      const allRows = this.modelGrd.collectionView.items
      const checkedRows = allRows.filter(d => d._status.checked)
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = that.modelGrd.columns.getColumn(itemKey)
          const colValue = row[itemKey]
          if (column !== null && column.isRequired) {
            switch (column.binding) {
              case 'fab':
              case 'eqpId':
              case 'moduleId':
                if (that.isEmpty(row[itemKey])) {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
                  return true
                }
                break
              default:
                if (that.isEmpty(colValue)) {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [column.header]))
                  return true
                }
                break
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
        // 중복값
        var dupIdx = this.rowItemDupCheck(row)
        if (dupIdx > 0) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['line : ' + dupIdx]))
          return true
        }
      })
    },
    /**
     * row data 중복 체크
     * @param {*} item row data
     * @returns {Boolean} 중복 체크 결과
     */
    rowItemDupCheck (item) {
      let flex = this.modelGrd
      let dupIdx = 0
      flex.rows.some((row, idx) => {
        switch (this.modelType) {
          case 'UVA':
            if (this.itemUVADupCheck(item, row.dataItem)) {
              dupIdx = idx + 1
              return true
            }
            break
          case 'MVA':
            if (this.itemMVADupCheck(item, row.dataItem)) {
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    /**
     * UVA model 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemUVADupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.paramName === dataItem.paramName && item.recipeId === dataItem.recipeId && item.stepId === dataItem.stepId
    },
    /**
     * MVA model 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemMVADupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.modelName === dataItem.modelName
    },
    /**
     * Detection Model 저장
     */
    // async saveData () {
    //   const that = this
    //   const allRows = this.$refs.modelGrd.rows
    //   let saveRows = []
    //   const checkedRows = this.$refs.modelGrd.checkedRows
    //   const totalModifiedRows = this.$refs.modelGrd.totalModifiedRows
    //   // 선택된 데이터가 없습니다.
    //   if (checkedRows < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
    //     return
    //   }

    //   allRows.some(row => {
    //     const rowStatus = row.dataItem._status
    //     // 변경되어 선택된 저장 대상
    //     if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
    //       const item = _.clone(row.dataItem)
    //       delete item['_status']
    //       saveRows.push(item)
    //     }
    //   })

    //   // 변경된 데이터가 없습니다.
    //   if (saveRows < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
    //     return
    //   }

    //   let confirmMessage = ''
    //   const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
    //   const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
    //   if (!_.isEqual(saveRows.length, totalModifiedRows.length)) {
    //     confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
    //   }
    //   confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

    //   if (this.saveDataValidCheck()) {
    //     return
    //   }

    //   let payload = {
    //     modelType: this.modelType,
    //     dataList: saveRows
    //   }

    //   this.$dialog.confirm({
    //     message: confirmMessage,
    //     confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
    //     cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
    //     onConfirm: async function () {
    //       const responseData = await API.FdcDetection.saveModelList(payload)
    //       if (responseData != null && responseData.status === 200) {
    //         that.$dialog.alert(successMessage)
    //         that.refreshModel()
    //       } else {
    //         that.$dialog.alert(failMessage)
    //       }
    //     }
    //   })
    // },
    /**
     * Detection Model 삭제
     */
    // async deleteData () {
    //   const that = this
    //   const checkedRows = []
    //   const allRows = this.$refs.modelGrd.rows
    //   let addedRow = []
    //   let deleteRow = []

    //   allRows.some(row => {
    //     const rowStatus = row.dataItem._status
    //     // 변경되어 선택된 저장 대상
    //     if (rowStatus.checked) {
    //       checkedRows.push(row.dataItem)
    //       if (rowStatus.added) {
    //       // 추가되어 그냥 삭제 할 로우
    //         addedRow.push(row.dataItem)
    //       } else {
    //         // 데이터 삭제 할 로우
    //         const item = _.clone(row.dataItem)
    //         delete item['_status']
    //         deleteRow.push(item)
    //       }
    //     }
    //   })

    //   if (checkedRows < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
    //     return
    //   }

    //   const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')
    //   const complateMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

    //   let payload = {
    //     modelType: this.modelType,
    //     dataList: deleteRow
    //   }

    //   this.$dialog.confirm({
    //     message: confirmMessage,
    //     confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
    //     cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
    //     onConfirm: async function () {
    //       if (deleteRow.length > 0) {
    //         await API.FdcDetection.deleteModelList(payload)
    //       }
    //       that.$dialog.alert(complateMessage)
    //       that.refreshModel()
    //     }
    //     // onCancel: function () {}
    //   })
    // },
    /**
     * 저장된 데이터 불러올때 Combo설정
     */
    _updateComboBoxInGrid (rows) {
    },
    /**
     * Step dataMap 설정
     * @param {*} selectEqpVo 현재 row의 data (입력한 Recipe ID 포함)
     * @param {*} currentRowItem 현재 row의 data
     */
    async getStepDataMap (selectEqpVo, currentRowItem) {
      this.stepDataMap = await API.BaseInfo.getEqpRecipeSteps(selectEqpVo)
      this.stepDataMap = [{ stepId: 'ALL' }].concat(this.stepDataMap)
      let stepList = ''
      this.stepDataMap.forEach(item => {
        stepList = stepList.concat(item.stepId, ',')
      })
      currentRowItem.stepList = stepList
      // this.dataMapSetting(this.stepDataMap, 'stepId')
    },
    /**
     * 입력값에 대한 dataMap 설정
     * @param {Array} dataMap data map에 설정할 data 배열
     * @param {String} colName column name
     */
    dataMapSetting (dataMap, colName) {
      const col = this.modelGrd.getColumn(colName)
      col.dataMap = new wjGrid.DataMap(dataMap, colName, colName)
    }
  },
  data () {
    return {
      columns: [], // grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // Detection Model grid row data
      paramNameDataMap: [], // Detection Model grid Parameter Name column dataMap
      recipeDataMap: [{ recipeId: 'ALL' }], // Detection Model grid Recipe column dataMap
      stepDataMap: [{ stepId: 'ALL' }], // Detection Model grid Step column dataMap
      searchTreeNode: [], // 검색된 EQP Tree node
      collectionViewOptions: {}, // Detection Model grid collectionView Option
      filterParam: null, // Parameter filter data
      filterParamArray: [], // Parameter filter combobox data
      filterRecipe: null, // Recipe filter data
      filterRecipeArray: [], // Recipe filter combobox data
      filterStep: null, // Step filter data
      filterStepArray: [], // Step filter combobox data
      eqpCopyModal: { visible: false } // 기준정보 Copy Modal 표시 여부
    }
  }
}
